import {Button, Divider, Typography} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import ContingentBeneficiaryDialog from 'ApplicationEntry/components/WorkFlow/ContingentBeneficiary/ContingentBeneficiaryDialog';
import ContingentBeneficiaryTabularList from 'ApplicationEntry/components/WorkFlow/ContingentBeneficiary/ContingentBeneficiaryTabularList';
import {ApplicationModeType} from 'ApplicationEntry/models/ApplicationModeType';
import {getAllHealthProducts, getAllLifeProducts, matchCaseDetailsByType} from 'ApplicationEntry/models/CaseDetails';
import {MAX_CONTINGENT_BENEFICIARY} from 'ApplicationEntry/models/ContingentBeneficiary';
import * as MA from 'ApplicationEntry/models/ModalApplication';
import {isLoadedPolicyTypes} from 'ApplicationEntry/models/PolicyTypes';
import React, {useState} from 'react';
import './ContingentBeneficiary.sass';

type ContingentBeneficiaryProps = {
  modalApplication: MA.InvalidModalApplication | MA.ValidModalApplication;
};

export default function ContingentBeneficiaryDashboard(props: ContingentBeneficiaryProps) {
  const {application, mode} = props.modalApplication;

  const [open, setOpen] = useState(false); //update these variable names

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getTotalPercent = () => {
    return application.contingentBeneficiaryList.contingentBeneficiaryList.reduce((a, b) => a + b.percent, 0);
  };

  const isQuality = mode === ApplicationModeType.Quality;

  const dashboardDetails = () => {
    return (
      <div className="contingent-beneficiary-section">
        <div className="contingent-beneficiary-section__main-header">
          <Typography variant="subtitle1" className="contingent-beneficiary-section__head" color="primary">
            Contingent Beneficiaries List
          </Typography>
          {
            <Button
              variant="contained"
              color="primary"
              onClick={handleClickOpen}
              disabled={
                application.contingentBeneficiaryList.contingentBeneficiaryList.size >= MAX_CONTINGENT_BENEFICIARY
                  ? true
                  : false
              }
            >
              ADD CONTINGENT BENEFICIARY
            </Button>
          }
        </div>
        {application.contingentBeneficiaryList.contingentBeneficiaryList.size < 1 ? (
          <>
            <div className="contingent-beneficiary-section__no-item">
              <div className="contingent-beneficiary-section__box">
                <div className="contingent-beneficiary-section__image" />

                <h3 className="contingent-beneficiary-section__title">No Associated Contingent Beneficiary</h3>
                <Typography className="contingent-beneficiary-section__content" variant="body2" color="initial">
                  Click the "Add Contingent Beneficiary" button above to add a beneficiary
                </Typography>
              </div>
            </div>
          </>
        ) : (
          <ContingentBeneficiaryTabularList
            contingentBeneficiaryItem={application.contingentBeneficiaryList}
            mode={mode}
          />
        )}

        <ContingentBeneficiaryDialog
          dialogOpen={open}
          dialogClose={handleClose}
          dialogTitle="Add Contingent Beneficiaries"
          dialogSubTitle="Beneficiary Information"
          dialogAdditional="ADDITIONAL BENEFICIARY"
          contingentBeneficiaryIndex={0}
          editContingentBeneficiary={false}
        />
        <div>
          {getTotalPercent() < 100 && getTotalPercent() > 0 ? (
            <Alert severity="warning">Sum of percent is not 100%.</Alert>
          ) : null}
        </div>
        <Divider className="application-form__actions-divider" />
      </div>
    );
  };

  const isLifeProductSelected = () => {
    const products = application.caseDetails.productType;

    if (
      isLoadedPolicyTypes(products) &&
      products.selectedPolicyTypes.some(p =>
        getAllLifeProducts.some(x => p.productGroup!.toLowerCase() === x.productGroup!.toLowerCase())
      )
    ) {
      return true;
    }
    return false;
  };

  const isHealthProductSelected = () => {
    const products = application.caseDetails.productType;
    if (
      isLoadedPolicyTypes(products) &&
      products.selectedPolicyTypes.some(p =>
        getAllHealthProducts.some(x => p.productGroup!.toLowerCase() === x.productGroup!.toLowerCase())
      )
    ) {
      return true;
    }
    return false;
  };

  return matchCaseDetailsByType({
    Group: () => dashboardDetails(),
    Ordinary: () => dashboardDetails(),
    NewYork: () => dashboardDetails(),
  })(application.caseDetails);
}
